import styles from './PrimaryButton.module.css'
import classNames from 'classnames'
import type { PrimaryVariantTypes } from '../../Button.types'
import ButtonContent from '../../Content/ButtonContent'
import ButtonTag from '../../Tag/ButtonTag'

const PrimaryButton = (props: PrimaryVariantTypes) => {
  const {
    color = 'black',
    size = 'medium',
    isUppercase = true,
    isLoading,
    isRounded,
    isFullWidth,
    hasShadow,
    noBorder,
    noHoverFill,
    ...restProps
  } = props

  const blockClasses = classNames({
    [styles.PrimaryButton]: true,
    [styles[`PrimaryButton--is-${color}`]]: true,
    [styles[`PrimaryButton--is-${size}`]]: true,
    [styles[`PrimaryButton--is-uppercase`]]: isUppercase,
    [styles['PrimaryButton--is-loading']]: isLoading,
    [styles[`PrimaryButton--is-rounded`]]: isRounded,
    [styles['PrimaryButton--is-full-width']]: isFullWidth,
    [styles['PrimaryButton--has-shadow']]: hasShadow,
    [styles['PrimaryButton--has-no-border']]: noBorder,
    [styles['PrimaryButton--no-hover-fill']]: noHoverFill,
  })

  return (
    <ButtonTag props={restProps} internalClass={blockClasses}>
      <ButtonContent {...props} />
      {isLoading ? <LoadingIcon /> : null}
    </ButtonTag>
  )
}

//TODO: Move this to icon component
const LoadingIcon = () => (
  <div className={styles['PrimaryButton__loading-container']}>
    <svg width="24" height="24" className={styles['PrimaryButton__loading-icon']}>
      <path
        d="M 12 2 L 12 6 M 12 18 L 12 22 M 4.93 4.93 L 7.76 7.76 M 16.24 16.24 L 19.07 19.07 M 2 12 L 6 12 M 18 12 L 22 12 M 4.93 19.07 L 7.76 16.24 M 16.24 7.76 L 19.07 4.93"
        fill="transparent"
        strokeWidth="2"
        stroke="rgb(255, 255, 255)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)

export default PrimaryButton
